import type { ClientOptions, InferRpcClient } from "@redotech/rpc/client";
import { createRpcClient } from "@redotech/rpc/client";
import { rpcDefinition } from "./definition";

export function createRedoMarketplaceRpcClient(
  options: ClientOptions<typeof rpcDefinition>,
): InferRpcClient<typeof rpcDefinition> {
  return createRpcClient(rpcDefinition, options);
}

export type RedoMarketplaceRpcClient = ReturnType<
  typeof createRedoMarketplaceRpcClient
>;
